module.exports = __webpack_public_path__ + "static/media/communitylifeicon-white.f5fcab0f.png";